const HEADER_SELECTOR: string = "[data-header]";

import cookies from 'simple-cookies';

export class CookieUI {

  public constructor(private $base: HTMLElement) {
  }

  public getParameter() : string[] {
    const URL_SELECTOR = window.location.href;
    let URL_INFO = URL_SELECTOR.split('&');
    URL_INFO[0] = URL_INFO[0].split("?")[1];
    const parameters : string[] = URL_INFO.map((parameter) => {
      if (typeof parameter !== 'undefined') {
        return parameter.split("=")[1];
      }
    });
    return parameters;
  }

  public saveParameter() {
    const parameter = this.getParameter();
    const ref = document.referrer
    localStorage.setItem('cookieReferrer', ref);

    if (parameter[0]) {
      if (parameter[0] == undefined) {

      } else {
        localStorage.setItem('cookieCampaign', parameter[0]);
      }
    }

    if (parameter[1]) {
      if (parameter[1] == undefined) {

      } else {
        localStorage.setItem('cookieSource', parameter[1]);
      }
    }

    if (parameter[2]) {
      if (parameter[2] == undefined) {

      } else {
        localStorage.setItem('cookieMedium', parameter[2]);
      }
    }

    if (parameter[3]) {
      if (parameter[3] == undefined) {

      } else {
        localStorage.setItem('cookieContent', parameter[3]);
      }
    }

    if (parameter[4]) {
      if (parameter[4] == undefined) {

      } else {
        localStorage.setItem('cookieTerm', parameter[4]);
      }
    }
  }


  public checkReferrer(referrer) {
    /* if (!document.referrer) {
      cookies.remove('cmLeadCookie30d');
      cookies.set('cmLeadCookie30d', 'direct', {
        path: '/',
        days: 30,
      });
    }
    else {
      referrer();
    } */
  }

  public setTrackingCookie() {
   /*  cookies.remove('cmLeadCookie30d');
    cookies.set('cmLeadCookie30d', JSON.stringify(this.getParameter()), {
      path: '/',
      days: 30,
    }); */
  }

  public isNewsletterReferer() {
    const parameter = this.getParameter();

    if (parameter.filter((item) => item === "newsletter").length > 0) {
      return true;
    }

    return false;
  }

  public createNewsletterCookie() {
    cookies.remove('allowNewsletterPopup');
    cookies.set('allowNewsletterPopup', 'false', {
      path: '/',
      days: 365,
    });
  }
}


export function createCookieUI() {
  const $base = document.querySelectorAll(HEADER_SELECTOR);
  let uiInstances: CookieUI[] = [];

  for (let index = 0; index < $base.length; index++) {
    const element = $base[index] as HTMLElement;
    uiInstances.push(new CookieUI(element));
  }

  return uiInstances;
}
